import { useState, ReactEventHandler, CSSProperties, SyntheticEvent } from 'react';
import { getImageSources } from '../../lib/optimizedAssets';

interface LazyImageProps {
    src: string;
    alt: string;
    className?: string;
    onError?: ReactEventHandler<HTMLImageElement>;
    style?: CSSProperties;
}

export function LazyImage({ src, alt, className, onError, style }: LazyImageProps) {
    const [imageError, setImageError] = useState(false);

    // Extract filename from src path for optimized sources
    const filename = src.replace(/^\//, ''); // Remove leading slash
    const sources = getImageSources(filename);

    const handleError = (e: SyntheticEvent<HTMLImageElement>) => {
        setImageError(true);
        if (onError) {
            onError(e);
        }
    };

    // If there was an error or the src is already optimized, use the original src
    if (imageError || src.includes('/optimized/')) {
        return (
            <img
                src={src}
                alt={alt}
                className={className}
                onError={onError}
                style={style}
            />
        );
    }

    return (
        <picture>
            <source srcSet={sources.avif} type="image/avif" />
            <source srcSet={sources.webp} type="image/webp" />
            <img
                src={sources.fallback}
                alt={alt}
                className={className}
                onError={handleError}
                style={style}
            />
        </picture>
    );
}
